import { Information } from "../../../../domain/entities/information";
import InformationInterface from "./information_interface";
import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import http from "../../http";

class InformationRepository implements InformationInterface {
  async list(): Promise<Information[]> {
    return wrapErrorHandler<Information[]>(async () => {
      const response = await http.get("/api/decola/faq/list");

      return response.data;
    });
  }

  async listLandingPage(): Promise<Information[]> {
    return wrapErrorHandler<Information[]>(async () => {
      const response = await http.get("/api/list/faq");

      return response.data;
    });
  }
}

export default new InformationRepository() as InformationInterface;
